import { Injectable } from '@angular/core';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { Store as StoreModel } from '@core/models';
import { StoreDeliveryCodeEnum } from '../../enums';
import { StoresProcessor } from '../../../../domain';
import { IStoreCardComponent, IStoreCardPresenter } from './interfaces';

@Injectable()
export class StoreCardPresenter
	extends IAbstractPresenter<IStoreCardComponent>
	implements IStoreCardPresenter
{
	constructor(private readonly storesProcessor: StoresProcessor) {
		super();
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	getScheduleText(
		store: StoreModel,
		code: StoreDeliveryCodeEnum,
		isAvailable: boolean,
		translations: ILanguageObject
	): string {
		const status = isAvailable
			? translations['open'] || 'Open'
			: translations['closed'] || 'Closed';
		const time = this.storesProcessor.getStoreScheduleTime(store, code, isAvailable);
		return `${status} - ${time}`;
	}

	onSelectStore(store: StoreModel, code: StoreDeliveryCodeEnum): void {
		this.view?.selected.emit({ store, code });
	}
}
